import { Component, Injector, OnInit, HostBinding } from '@angular/core';
import { BaseComponent } from '@shared/base/Base.Component';

@Component({
    selector: 'em-settings-options',
    templateUrl: './Settings.Options.Component.html',
    styleUrls: ['./Settings.Options.Component.scss']
})
export class SettingsOptionsComponent extends BaseComponent implements OnInit {
    public static className: string = 'SettingsOptionsComponent';

    @HostBinding()
    public id: string = 'em-settings-options';

    public constructor(
        private readonly _injector: Injector) {
        super(_injector);
    }

    public ngOnInit(): void {
        super.ngOnInit();
    }
}
